module.exports = __webpack_public_path__ + "media/images/cash-pay-4e9fcf9aac2cd633ccb201d85cce5b11.png";